<template>
  <div class="materials-banner">
    <div class="materials-banner__counter">
      <span v-if="totalMaterials">
        <img
          src="/img/materials/banner/i-articles.svg"
          alt="articles"
        >
        {{ totalMaterials }}
      </span>
      <span v-if="totalLikes">
        <img
          src="/img/materials/banner/i-like.svg"
          alt="likes"
        >
        {{ totalLikes }}
      </span>
      <span v-if="totalViewsCount">
        <img
          src="/img/materials/banner/i-views.svg"
          alt="views"
        >
        {{ totalViewsCount }}
      </span>
    </div>
    <p class="materials-banner__text">
      помогаем родителям и детям ориентироваться в мире онлайн‑образования
    </p>
    <img
      src="/img/materials/banner/media.png"
      alt="media"
      class="materials-banner__media no-tablet-adaptive"
    >
    <img
      src="/img/materials/banner/school.png"
      alt="school"
      class="materials-banner__school no-tablet-adaptive"
    >

    <img
      src="/img/materials/banner/media-mob.png"
      alt="media"
      class="materials-banner__media tablet-adaptive"
    >
    <img
      src="/img/materials/banner/school-mob.png"
      alt="school"
      class="materials-banner__school tablet-adaptive"
    >
  </div>
</template>

<script>
export default {
  name: 'MaterialsBanner',
  data: () => ({
    totalMaterials: 0,
    totalViewsCount: 0,
    totalLikes: 0,
  }),
  async fetch() {
    await this.fetchMaterialsStatistic();
  },
  methods: {
    async fetchMaterialsStatistic() {
      const response = await this.$api.getMaterialsStatistic();
      this.totalMaterials = response?.totalCount;
      this.totalViewsCount = response?.totalViewsCount;
      this.totalLikes = response?.totalLikesCount;
    },
  },
};
</script>

<style scoped lang="scss">

.materials-banner {
  position: relative;
  padding: calc(var(--scale) * 32) calc(var(--scale) * 40);
  height: calc(var(--scale) * 350);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  background-image: url("/img/materials/banner/bg.webp");
  background-size: 100% 100%;

  @include media-down($size-tablet) {
    height: calc(var(--scale) * 320);
    padding: calc(var(--scale) * 16);
    background-image: url("/img/materials/banner/bg-tablet.webp");
  }

  @include media-down($size-mobile) {
    flex-direction: column-reverse;
    justify-content: flex-end;
    gap: calc(var(--scale) * 12);
    height: calc(var(--scale) * 320);
    padding: calc(var(--scale) * 20) calc(var(--scale) * 16);
    background-image: url("/img/materials/banner/bg-mob.webp");
  }

  .materials-banner__counter {
    display: flex;
    gap: calc(var(--scale) * 20);
    align-items: center;

    @include media-down($size-tablet) {
      gap: calc(var(--scale) * 16);
    }

    span {
      display: inline-flex;
      align-items: center;
      gap: calc(var(--scale) * 6);
      font-weight: 400;
      font-size: calc(var(--scale) * 20);
      line-height: 130%;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        gap: calc(var(--scale) * 4);
        font-weight: 500;
        font-size: calc(var(--scale) * 14);
      }
    }

    img {
      width: calc(var(--scale) * 32);

      @include media-down($size-tablet) {
        width: calc(var(--scale) * 24);
      }
    }
  }

  .materials-banner__text {
    max-width: calc(var(--scale) * 686);
    font-weight: 500;
    font-size: calc(var(--scale) * 48);
    line-height: 110%;
    text-align: right;
    letter-spacing: -0.02em;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      margin-top: calc(var(--scale) * 4);
      max-width: calc(var(--scale) * 334);
      font-size: calc(var(--scale) * 20);
    }

    @include media-down($size-mobile) {
      text-align: left;
    }
  }

  .materials-banner__media {
    height: calc(var(--scale) * 78);
    position: absolute;
    top: calc(var(--scale) * 72);
    left: calc(var(--scale) * 41);

    @include media-down($size-tablet) {
      height: calc(var(--scale) * 67);
      top: calc(var(--scale) * 140);
      left: calc(var(--scale) * 12);
    }

    @include media-down($size-mobile) {
      top: calc(var(--scale) * 180);
    }
  }

  .materials-banner__school {
    height: calc(var(--scale) * 224);
    position: absolute;
    bottom: calc(var(--scale) * 2);
    left: 0;

    @include media-down($size-tablet) {
      height: auto;
      width: calc(var(--scale) * 606);
      left: calc(var(--scale) * 7);
      bottom: calc(var(--scale) * 3);
    }

    @include media-down($size-mobile) {
      width: calc(var(--scale) * 368);
      left: calc(-1 * var(--scale) * 1);
      bottom: calc(var(--scale) * 12);
    }
  }
}

</style>
